<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }" appPadding="0">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
    <!--Laboratory form  -->

    <div class="ui form" [formGroup]="companyEquipmentForm">
      <div class="field" [ngClass]="displayFieldCss('equipName')">
        <label class="required">Equipment Name</label>
        <input
          formControlName="equipName"
          type="text"
          placeholder="Equipment Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('equipName')"
          errorMsg="Please enter equipment name"
        >
        </app-field-error-display>
      </div>

      <div class="field" [ngClass]="displayFieldCss('equipModelNumber')">
        <label>Equipment Model Number</label>
        <input
          formControlName="equipModelNumber"
          type="text"
          placeholder="Equipment Model Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('equipModelNumber')"
          errorMsg="Please enter equipment model number"
        >
        </app-field-error-display>
      </div>
      <!-- <div class="field" [ngClass]="displayFieldCss('manufacturerName')">
        <label>Equipment Manufacture Name</label>
        <input
          formControlName="manufacturerName"
          type="text"
          placeholder="Equipment Manufacture Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('manufacturerName')"
          errorMsg="Please enter equipment manufacture Name"
        >
        </app-field-error-display>
      </div> -->
      <div class="field" [ngClass]="displayFieldCss('equipTypeId')">
        <label>Equipment Type</label>
        <sui-select
          class="selection"
          formControlName="equipTypeId"
          [options]="equipmentTypes"
          labelField="optionName"
          valueField="optionId"
          [isSearchable]="searchable"
          #selecdt
        >
          <sui-select-option
            *ngFor="let option of selecdt.filteredOptions"
            [value]="option"
          >
          </sui-select-option>
        </sui-select>
        <app-field-error-display
          [displayError]="isFieldValid('equipTypeId')"
          errorMsg="Please select equipment type"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('yearOfManufacture')">
        <label>Year of Manufacture</label>
        <div class="ui right icon input">
          <i class="calendar icon"></i>
          <input
            type="text"
            formControlName="yearOfManufacture"
            suiDatepicker
            pickerPlacement="top left"
            [pickerMode]="mode"
            placeholder="Year of Manufacture"
          />
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('yearOfManufacture')"
          errorMsg="Please select year of manufacturing"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || !companyEquipmentForm.valid"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
